import React from 'react'

import { Icon } from '@telavita-core/react-design-kit'

import { RestrictionsStatus } from 'services/reservation'
import { Patient } from '../../types'

import { 
  OnlyParticularReservation, 
  PatientAlreadyHasReservation, 
  PatientAlreadyHasSchedule, 
  PlanNotAllowReservation 
} from './components'

import * as S from './styles'

interface FeedbackRestrictionProps {
  restriction: RestrictionsStatus | string
  patient: Patient
  handleContinueWithReservation?: () => void
  showIcon?: boolean
  totalPatientSchedule?: number
}

export function FeedbackPatientRestriction({
  patient,
  restriction,
  handleContinueWithReservation,
  showIcon = true,
  totalPatientSchedule = 0
}: FeedbackRestrictionProps): JSX.Element {
  const onlyParticularPlanAllowReservation = restriction === RestrictionsStatus.ONLY_PARTICULAR_PLAN_ALLOW_RESERVATION
  const planNotAllowReservation = restriction === RestrictionsStatus.NO_PLAN_GROUP_ALLOWS_RESERVATION
  const patientAlreadyHasReservation = restriction === RestrictionsStatus.PATIENT_ALREADY_HAS_RESERVATION
  const patientAlreadyHasSchedule = restriction === RestrictionsStatus.PATIENT_ALREADY_HAS_SCHEDULE

  const [patientFirstName] = patient.fullName.split(' ')

  return (
    <S.FeedbackRestrictionContainer>

      {showIcon && (
        <Icon name='NoReservation'/>
      )}

      {patientAlreadyHasSchedule && (
        <PatientAlreadyHasSchedule 
          totalSchedules={totalPatientSchedule}
          handleContinueWithReservation={handleContinueWithReservation}
          patientFirstName={patientFirstName}
        />
      )}

      {patientAlreadyHasReservation && (
        <PatientAlreadyHasReservation 
          patientFirstName={patientFirstName} 
        />
      )}

      {onlyParticularPlanAllowReservation && (
        <OnlyParticularReservation 
          handleContinueWithReservation={handleContinueWithReservation} 
        />
      )}

      {planNotAllowReservation && (
        <PlanNotAllowReservation />
      )}

    </S.FeedbackRestrictionContainer>
  )
} 